const Account = () => import(/* webpackChunkName: "account" */ 'Portal/components/Account/Account')

// Routes
export default [
    {
        path: 'account',
        name: 'account',
        component: Account
    }
]
